import { ref } from 'vue'

export const THEMES = [
  { id: 'navy',   label: 'Azul Marino', icon: '🔵' },
  { id: 'light',  label: 'Claro',       icon: '☀️' },
  { id: 'clean',  label: 'Verde',       icon: '🟢' },
  { id: 'slate',  label: 'Oscuro',      icon: '⚫' },
  { id: 'violet', label: 'Violeta',     icon: '🟣' }
]

const VALID_IDS = THEMES.map(t => t.id)

const getInitialTheme = () => {
  const saved = localStorage.getItem('g360-theme')
  return VALID_IDS.includes(saved) ? saved : 'navy'
}

const currentTheme = ref(getInitialTheme())
let themeLink = null

const applyTheme = (id) => {
  if (!VALID_IDS.includes(id)) id = 'navy'

  // Remover tema anterior
  if (themeLink) { themeLink.remove(); themeLink = null }

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `/themes/theme-${id}.css`
  link.id = 'g360-theme'
  document.head.appendChild(link)
  themeLink = link

  document.body.dataset.theme = id
}

export function useTheme() {
  const cambiarTema = (id) => {
    currentTheme.value = id
    localStorage.setItem('g360-theme', id)
    applyTheme(id)
  }

  // Aplicar al montar si no está ya aplicado
  if (!document.getElementById('g360-theme')) {
    applyTheme(currentTheme.value)
  }

  return { currentTheme, cambiarTema, THEMES }
}
